module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.visible),
      expression: "visible"
    }],
    staticClass: "search"
  }, [_c('el-form', {
    ref: "form",
    attrs: {
      "model": _vm.form,
      "label-width": "100px"
    }
  }, [_c('el-row', {
    staticClass: "row-bg",
    attrs: {
      "type": "flex"
    }
  }, [_c('el-col', {
    attrs: {
      "span": 5
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "幼儿园名称:"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请输入名称"
    },
    model: {
      value: (_vm.form.SchoolName),
      callback: function($$v) {
        _vm.$set(_vm.form, "SchoolName", $$v)
      },
      expression: "form.SchoolName"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 5
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "所属代理商:"
    }
  }, [_c('el-select', {
    staticClass: "inputwidth",
    attrs: {
      "filterable": "",
      "placeholder": "请选择或搜索"
    },
    model: {
      value: (_vm.form.AgentCustomerId),
      callback: function($$v) {
        _vm.$set(_vm.form, "AgentCustomerId", $$v)
      },
      expression: "form.AgentCustomerId"
    }
  }, _vm._l((_vm.AgentList), function(item) {
    return _c('el-option', {
      attrs: {
        "label": item.Customer,
        "value": item.Id
      }
    })
  }))], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 10
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "提交时间:"
    }
  }, [_c('el-date-picker', {
    staticStyle: {
      "width": "40%"
    },
    attrs: {
      "type": "date",
      "placeholder": "选择日期"
    },
    model: {
      value: (_vm.form.createTimeStart),
      callback: function($$v) {
        _vm.$set(_vm.form, "createTimeStart", $$v)
      },
      expression: "form.createTimeStart"
    }
  }), _vm._v(" "), _c('span', [_vm._v("到")]), _vm._v(" "), _c('el-date-picker', {
    staticStyle: {
      "width": "40%"
    },
    attrs: {
      "type": "date",
      "placeholder": "选择日期"
    },
    model: {
      value: (_vm.form.createTimeEnd),
      callback: function($$v) {
        _vm.$set(_vm.form, "createTimeEnd", $$v)
      },
      expression: "form.createTimeEnd"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "success",
      "icon": "search"
    },
    on: {
      "click": _vm.search
    }
  }, [_vm._v("搜索")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "default",
      "icon": "delete"
    },
    on: {
      "click": _vm.reset
    }
  }, [_vm._v("重置")])], 1)], 1)], 1), _vm._v(" "), _c('el-row', {
    staticClass: "row-bg",
    attrs: {
      "type": "flex"
    }
  }, [_c('el-col', {
    attrs: {
      "span": 5
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "园长:"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请输入名称"
    },
    model: {
      value: (_vm.form.PrincipalName),
      callback: function($$v) {
        _vm.$set(_vm.form, "PrincipalName", $$v)
      },
      expression: "form.PrincipalName"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 5
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "电话:"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请输入电话"
    },
    model: {
      value: (_vm.form.PhoneNo),
      callback: function($$v) {
        _vm.$set(_vm.form, "PhoneNo", $$v)
      },
      expression: "form.PhoneNo"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 10
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "审核时间:"
    }
  }, [_c('el-date-picker', {
    staticStyle: {
      "width": "40%"
    },
    attrs: {
      "type": "date",
      "placeholder": "选择日期"
    },
    model: {
      value: (_vm.form.startTime),
      callback: function($$v) {
        _vm.$set(_vm.form, "startTime", $$v)
      },
      expression: "form.startTime"
    }
  }), _vm._v(" "), _c('span', [_vm._v("到")]), _vm._v(" "), _c('el-date-picker', {
    staticStyle: {
      "width": "40%"
    },
    attrs: {
      "type": "date",
      "placeholder": "选择日期"
    },
    model: {
      value: (_vm.form.endTime),
      callback: function($$v) {
        _vm.$set(_vm.form, "endTime", $$v)
      },
      expression: "form.endTime"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 8
    }
  })], 1), _vm._v(" "), _c('el-row', {
    staticClass: "row-bg",
    attrs: {
      "type": "flex"
    }
  }, [_c('el-col', {
    attrs: {
      "span": 5
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "订单号:"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.form.OrderCode),
      callback: function($$v) {
        _vm.$set(_vm.form, "OrderCode", $$v)
      },
      expression: "form.OrderCode"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 5
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "所属套餐:"
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "placeholder": "请选择"
    },
    model: {
      value: (_vm.form.PackageId),
      callback: function($$v) {
        _vm.$set(_vm.form, "PackageId", $$v)
      },
      expression: "form.PackageId"
    }
  }, _vm._l((_vm.PackageTypes), function(item) {
    return _c('el-option', {
      attrs: {
        "label": item.text,
        "value": item.id
      }
    })
  }))], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 5
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "状态:"
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "79%"
    },
    attrs: {
      "placeholder": "请选择"
    },
    model: {
      value: (_vm.form.AuditStatus),
      callback: function($$v) {
        _vm.$set(_vm.form, "AuditStatus", $$v)
      },
      expression: "form.AuditStatus"
    }
  }, _vm._l((_vm.status), function(item) {
    return _c('el-option', {
      attrs: {
        "label": item.text,
        "value": item.id
      }
    })
  }))], 1)], 1), _vm._v(" "), _c('el-col', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (false),
      expression: "false"
    }],
    staticStyle: {
      "margin-left": "-3%"
    },
    attrs: {
      "span": 5
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "类型:"
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "79%"
    },
    attrs: {
      "placeholder": "请选择"
    },
    model: {
      value: (_vm.form.StatusType),
      callback: function($$v) {
        _vm.$set(_vm.form, "StatusType", $$v)
      },
      expression: "form.StatusType"
    }
  }, _vm._l((_vm.type), function(item) {
    return _c('el-option', {
      attrs: {
        "label": item.text,
        "value": item.id
      }
    })
  }))], 1)], 1), _vm._v(" "), _c('el-col', {
    staticStyle: {
      "margin-left": "-3%"
    },
    attrs: {
      "span": 5
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "审核类型:"
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "79%"
    },
    attrs: {
      "placeholder": "请选择"
    },
    model: {
      value: (_vm.form.ApplyType),
      callback: function($$v) {
        _vm.$set(_vm.form, "ApplyType", $$v)
      },
      expression: "form.ApplyType"
    }
  }, _vm._l((_vm.appTypes), function(item) {
    return _c('el-option', {
      attrs: {
        "label": item.text,
        "value": item.id
      }
    })
  }))], 1)], 1), _vm._v(" "), _c('el-col', {
    staticStyle: {
      "margin-left": "-3%"
    },
    attrs: {
      "span": 5
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "下单类型:"
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "79%"
    },
    attrs: {
      "placeholder": "请选择"
    },
    model: {
      value: (_vm.form.CheckType),
      callback: function($$v) {
        _vm.$set(_vm.form, "CheckType", $$v)
      },
      expression: "form.CheckType"
    }
  }, _vm._l((_vm.checkTypes), function(item) {
    return _c('el-option', {
      attrs: {
        "label": item.text,
        "value": item.id
      }
    })
  }))], 1)], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-2272a631!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/school/checkSchool/search/search.vue
// module id = 1418
// module chunks = 1